
const reducerProdutosTypes = {
    BUSCAR_PRODUTOS: "BUSCAR_PRODUTOS",
    SET_PRODUTOS: "SET_PRODUTOS" 
}

const ReducerProdutos = (state = { produtos: [], force: 0, reducerProdutosTypes: reducerProdutosTypes}, {type, payload}) => {
    let produtos = [];
    let loading = false;
    
    

    switch(type){
        case reducerProdutosTypes.SET_PRODUTOS:
            produtos = payload;
            var newObject = Object.assign({},state,{produtos}, {loading});
            return newObject;
        case reducerProdutosTypes.BUSCAR_PRODUTOS:
            loading = true;
            return Object.assign({}, /* {force}, */ {loading});
        default:
            return state;
    }
};







/* const defaultStateProdutos = { produtos: [], force: 0}; */
//export default {ReducerProdutos, defaultStateProdutos, reducerProdutosTypes};
export default ReducerProdutos;